<template>

    <div class="alerts" :class="{'hasNotify': hasNotify}" v-if="finishedLoading">
        <at-dropdown placement="bottom-right" class="notifications">
            <router-link :to="{ path: '/'+tipoUsuario+'/notificacoes' }" class="" title="Ver todas as notificações">
                <at-badge :value="13" dot>
                    <i class="ico-al"></i>
                </at-badge>
            </router-link>
                    <at-dropdown-menu slot="menu" v-if="notificacoes !== null && hasNotify">
                <at-dropdown-item>
                    <router-link :to="{ path: '/'+tipoUsuario+'/notificacoes' }" class="" title="Ver todas as notificações">
                        <h4 class="float-left">Notificações</h4>
                        <span class="float-right">
                            <img src="/static/assets/images/icon-go-2.svg" alt="">
                        </span>
                    </router-link>
                </at-dropdown-item>
                <!-- ARRAY - NOTIFICATIONS -->
                <at-dropdown-item v-for="notificacao in filterNotifications(notificacoes)" :key="notificacao._id">
                    <router-link :to="formatUrl(notificacao.Url)" class="" :title="notificacao.Titulo" :event="''" @click.native.prevent="changeStatus(notificacao._id, notificacao.Url)">
                        <!-- STATUS DA NOTIFICAÇÃO | Visualizado - success | Publicado - primary | Atencao - warning | Atrasado - danger -->
                        <span v-if="notificacao.Tipo === 'Pagamento'" class="icon icon-coin rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
                        <span v-else-if="notificacao.Tipo === 'Solicitacao'" class="icon icon-doc rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
                        <span v-else-if="notificacao.Tipo === 'Boleto'" class="icon icon-bar rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
                        <span v-else class="icon icon-infos rounded-circle" :class="verifyStatus(notificacao.Status)"></span>
                        <!-- ::::::::::::::::::::: -->
                        <div>
                            <h5>{{notificacao.Titulo}}</h5>
                            <p>
                                {{notificacao.Descricao}}
                                <span>{{convertDate(notificacao.Updated)}}</span>
                            </p>
                        </div>
                    </router-link>
                </at-dropdown-item>
                <!-- ::::::::::::::::::::::::::::: -->
                <at-dropdown-item>
                    <router-link :to="{ path: '/'+tipoUsuario+'/notificacoes' }" class="" title="Ver todas as notificações">Ver todas as notificações</router-link>
                </at-dropdown-item>
            </at-dropdown-menu>
        </at-dropdown>
    </div>
</template>

<script>
/* eslint-disable */
import ApiClient from '../utils/api-client'
import * as mutationTypes from '@/store/mutation-types.js'
import Masker from '@/utils/masker'
// import DateHelper from '@/utils/date-helper'

export default {

    data() {
        return {
            notificacoes: null,
            finishedLoading: false,
            hasNotify: false,
            statusGo: false
        }
    },
    methods: {
        filterNotifications(notifications) {
            let aux = [];
            let cont = 0;

            notifications.forEach(element => {
                if(element.Status !== 'Visualizado' && element.Status !== 'Deletado' && cont < 5) {
                    aux.push(element);
                    cont ++;
                }

                if(cont > 5) {
                    return true;
                }
            });

            return aux;
        },
        formatUrl(url) {
            let urlForm;

            if(url.indexOf("/") !== 0) {
                urlForm = url.replace(/^/gm, "/");
            } else {
                urlForm = url;
            }

            return urlForm;
        },
        verifyStatus(status) {
            let bgClass
            switch(status) {
                case 'Publicado':
                bgClass = 'bg-primary';
                break;

                case 'Atencao':
                bgClass = 'bg-warning';
                break;

                case 'Atrasado':
                bgClass = 'bg-danger';
                break;

                case 'Visualizado':
                bgClass = 'bg-success';
                break;
            }

            return bgClass;
        },
        changeStatus(id, url) {
            let status = "Visualizado";

            if(!this.statusGo) {
                ApiClient.changeStatusNotification(id, status)
                .then((response)=>{
                  if(response.status === 200) {
                    this.Atualizar(url);
                  }
                })
            }
        },
        convertDate(date) {
            let today = new Date();
            let timeStampToday = Math.round(today.getTime()/ 1000);
            let h = today.getHours();
            let m = today.getMinutes();
            let s = today.getSeconds()
            let arrayDate = Masker.maskIsoDate(date).split('/')
            let objDate   = new Date(arrayDate[2], arrayDate[1] - 1, arrayDate[0], h, m, s);
            let timeStampDate = Math.round(objDate.getTime() / 1000);
            let hours   = ((timeStampToday - timeStampDate) / 3600);
            let days    = parseInt(hours / 24);
            let msg;

            if(days <= 0) {
                msg = 'Enviado Hoje';
            } else if (days <= 4) {
              msg = `Enviado há ${days} dias`;
            } else {
              msg = `Enviado em: ${arrayDate[0]}/${arrayDate[1]}/${arrayDate[2]}`;
            }

            return msg;
        },
        Atualizar(url) {
            if(this.formatUrl(url) === this.$route.fullPath) {
                location.reload()
            } else {
                this.$router.push(this.formatUrl(url));
                this.finishedLoading = true;
            }
        }
    },
    props: ['from','tipoUsuario'],
    computed: {
        getFrom() {
            return this.from;
        }
    },
    watch: {
        $route(to, from) {
            this.$store.commit(mutationTypes.START_LOADING)

            
            // PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
            ApiClient.getUser()
            .then(user => {

                //verificar blacklist
                if(user.status == "BLACKLIST"){

                    const reloadPage = () => {
                        this.$router.push('/login')
                    }

                    localStorage.clear();
                    this.$store.dispatch('logout')
                    reloadPage()
                    return;
                }
                
                ApiClient.getNotificationsUser(user._id)
                .then(notifications => {
                    this.notificacoes = notifications;


                    if(notifications.length > 0) {
                        this.finishedLoading = true;
                    }

                    for(let i = 0; i < notifications.length; i++) {
                        if(notifications[i].Status !== 'Visualizado' && notifications[i].Status !== 'Deletado') {
                            this.hasNotify = true;
                            break;
                        } else {
                            this.hasNotify = false;
                        }
                    }

                    this.$store.commit(mutationTypes.STOP_LOADING);
                })
            
            })
            .catch(() =>{
                this.finishedLoading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
        }
    },
    beforeCreate() {
        this.$store.commit(mutationTypes.START_LOADING)

        // PROMISES FOR GET USER ID TO GET NOTIFICATIONS FROM USER
        ApiClient.getUser()
        .then(user => {ApiClient.getNotificationsUser(user._id)
        .then(notifications => {
            this.notificacoes = notifications;

            if(notifications.length > 0) {
                this.finishedLoading = true;
            }

            for(let i = 0; i < notifications.length; i++) {
                if(notifications[i].Status !== 'Visualizado' && notifications[i].Status !== 'Deletado') {
                    this.hasNotify = true;
                    break;
                } else {
                    this.hasNotify = false;
                }
            }

            this.$store.commit(mutationTypes.STOP_LOADING);
        })})
        .catch(() =>{
            this.finishedLoading = true;
            this.$store.commit(mutationTypes.STOP_LOADING);
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Alerts.vue